

export const wiperDuration = 0.75;
export const visibilityEnterDelay = 0.25;
export const visibilityEnterDuration = 0.1;
export const wiperDelay = 5*(visibilityEnterDelay + visibilityEnterDuration)/10;
export const baseAnimationDelay = visibilityEnterDelay + visibilityEnterDuration;